import { CheckIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { motion } from 'framer-motion';
import type { QuestionDefinition } from '../../../../types/checkin';

interface YesNoQuestionProps {
  question: QuestionDefinition;
  value: boolean | undefined;
  onChange: (value: boolean) => void;
}

export function YesNoQuestion({
  value,
  onChange,
}: YesNoQuestionProps) {
  return (
    <div className="flex gap-4">
      <motion.button
        onClick={() => onChange(true)}
        className={`
          relative flex-1 p-8 rounded-2xl border-4 transition-all duration-200
          ${
            value === true
              ? 'border-accent-500 bg-accent-50 dark:bg-accent-900/20 scale-105 shadow-lg'
              : 'border-surface-200 dark:border-surface-700 hover:border-surface-300 dark:hover:border-surface-600'
          }
        `}
        whileTap={{ scale: 0.95 }}
      >
        <div className="flex flex-col items-center gap-3">
          <div
            className={`
              w-16 h-16 rounded-full flex items-center justify-center transition-colors
              ${value === true ? 'bg-accent-500' : 'bg-surface-200 dark:bg-surface-700'}
            `}
          >
            <CheckIcon
              className={`h-8 w-8 ${value === true ? 'text-white' : 'text-surface-500 dark:text-surface-400'}`}
            />
          </div>
          <span
            className={`
              text-xl font-semibold
              ${value === true ? 'text-accent-700 dark:text-accent-300' : 'text-surface-700 dark:text-surface-300'}
            `}
          >
            Yes
          </span>
        </div>
      </motion.button>

      <motion.button
        onClick={() => onChange(false)}
        className={`
          relative flex-1 p-8 rounded-2xl border-4 transition-all duration-200
          ${
            value === false
              ? 'border-accent-500 bg-accent-50 dark:bg-accent-900/20 scale-105 shadow-lg'
              : 'border-surface-200 dark:border-surface-700 hover:border-surface-300 dark:hover:border-surface-600'
          }
        `}
        whileTap={{ scale: 0.95 }}
      >
        <div className="flex flex-col items-center gap-3">
          <div
            className={`
              w-16 h-16 rounded-full flex items-center justify-center transition-colors
              ${value === false ? 'bg-accent-500' : 'bg-surface-200 dark:bg-surface-700'}
            `}
          >
            <XMarkIcon
              className={`h-8 w-8 ${value === false ? 'text-white' : 'text-surface-500 dark:text-surface-400'}`}
            />
          </div>
          <span
            className={`
              text-xl font-semibold
              ${value === false ? 'text-accent-700 dark:text-accent-300' : 'text-surface-700 dark:text-surface-300'}
            `}
          >
            No
          </span>
        </div>
      </motion.button>
    </div>
  );
}
